(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/ticketgames/ticket-utility/assets/javascripts/utils/get-voucher.js') >= 0) return;  svs.modules.push('/components/ticketgames/ticket-utility/assets/javascripts/utils/get-voucher.js');
"use strict";

const getVoucherExpirationDate = async voucherId => {
  try {
    const _await$svs$tur$apiCal = await svs.tur.apiCaller.ticketgames.getVoucherById({
        voucherId
      }),
      response = _await$svs$tur$apiCal.response;
    return svs.utils.date.FormatTime('yyyy-MM-dd', response.lastValidDate);
  } catch (e) {
    return null;
  }
};
setGlobal('svs.ticketgames.ticketUtility.getVoucherExpirationDate', getVoucherExpirationDate);

 })(window);